import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getTenantAlias } from '../../hooks/getTenantAlias';

export enum IdentityProviderType {
  Oidc = 'Oidc',
  Saml = 'Saml',
}

export type IdentityProvider = {
  connectionId: string;
  name: string;
  userType: string;
  prompt: string;
  type?: IdentityProviderType;
};

export type LoginConfig = {
  providers: IdentityProvider[];
  shopperTenantId: string;
  staffTenantId: string;
  tenantId: string;
  tenantName: string;
  primaryConnectionId?: string;
  defaultLocale?: string;
};

type TenantInfoContextType = {
  tenantInfo?: LoginConfig;
  loading: boolean;
};

export const TenantInfoContext = React.createContext<TenantInfoContextType>({ loading: true });

export const TenantInfoProvider: React.FC = ({ children }) => {
  const [tenantInfo, setTenantInfo] = useState<LoginConfig | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTenantInfo = async () => {
      const loginConfigResponse = await axios.get<LoginConfig>(
        globalThis.location.hostname === 'localhost'
          ? `iam-api/v1/login-config?tenantAlias=${getTenantAlias()}`
          : `https://iam-api.retailsvc.com/api/v1/login-config?tenantAlias=${getTenantAlias()}`,
      );
      localStorage.setItem('tenantId', loginConfigResponse.data.tenantId);
      localStorage.setItem('staffTenantId', loginConfigResponse.data.staffTenantId);
      localStorage.setItem('shopperTenantId', loginConfigResponse.data.shopperTenantId);
      localStorage.setItem('defaultLocale', loginConfigResponse.data.defaultLocale || 'en');
      setTenantInfo(loginConfigResponse.data);
      setLoading(false);
    };
    fetchTenantInfo().then((r) => r);
  }, []);

  return (
    <TenantInfoContext.Provider value={{ tenantInfo, loading }}>
      {children}
    </TenantInfoContext.Provider>
  );
};
